export const generateUrl = (baseUrl: string, contractId: string, vehicleId: string, shouldShare: boolean): string => {
  const contractParam = contractId.length > 0 ? `contract_id=${contractId}` : null
  const contractVehicleParam = vehicleId.length > 0 ? `contract_vehicle_id=${vehicleId}` : null
  const shareParam = shouldShare ? 'share_with_supplier=true' : null

  const allParams = [contractParam, contractVehicleParam, shareParam].filter(Boolean)

  const paramLength = allParams.join('').length
  const queryParams = paramLength > 0 ? `?${allParams.join('&')}` : ''

  return `${baseUrl}${queryParams}`
}
